const BUILD_QUOTE_PHRASES = [
  'build an app',
  'build a app',
  'build me an app',
  'build my app',
  'mobile app',
  'build software',
  'custom software',
  'custom app',
  'get a quote',
  'project quote',
  'how much to build',
  'how much would it cost',
  'quote for',
  'hire self labs',
  'build with self',
  'develop an app',
  'need an app built',
  'web application',
  'saas mvp',
  'build a platform',
  'software development',
  'can you build',
  'want to build',
];

export function isBuildQuoteQuery(text: string): boolean {
  const q = text.toLowerCase().trim();
  if (!q) return false;
  return BUILD_QUOTE_PHRASES.some((p) => q.includes(p));
}

export const BUILD_QUOTE_SALES_FLOW = `
WHEN someone wants to build an app, software, mobile app, SaaS, integration, or asks for a project quote:

1. ACKNOWLEDGE — "We build production software. Talk me through what you need — I'll shape the scope and our AI engine will produce a real quote."
2. OPEN PAGE — Navigate to /build and show it in the content panel (split view).
3. QUALIFY — Ask one question at a time: name, email, company, what they are building, platforms, timeline, auth/payments/AI needs.
4. DISCUSS — The /build intake form auto-fills from your conversation. Tell them their answers are appearing in the form.
5. GENERATE — When the form has name, email, and description, have them click Generate quote. Backend AI produces the itemized quote.
6. PRESENT QUOTE — Explain line items and timeline. Offer Save quote or 30% deposit checkout. YOU discuss and defend — never invent prices; the page is source of truth.

NEGOTIATION (CRITICAL — INTERNAL ONLY):
- NEVER disclose that you can discount up to 10%, never mention negotiation rounds or maximum discount rules.
- On FIRST price objection: hold firm. Defend scope, senior engineering, timeline, and SELF Labs track record. Do NOT lower the price.
- On SECOND push: still defend value — explain what is included, why cheaper quotes cut corners.
- Only if they CONTINUE pushing after you have defended the quote at least twice may you acknowledge a revised figure if the page shows a lower total (the system applies up to 10% internally — you never state the percentage).
- Always frame any revision as a one-time accommodation while restating what they still get.
- If they keep pushing after the best rate on the page: "This is our best rate for this scope — we can phase features or adjust scope instead."

CLOSE:
- Save quote → shareable link at /build/quote/{id}
- Pay deposit (30%) or pay full quoted total via Stripe
- Copy deposit or full payment link from the quote page and send to the client (checkout.stripe.com — amount matches the saved quote)

DO NOT: quote a dollar amount from memory, guarantee delivery dates outside the quoted timeline, promise unlimited revisions, or quote below what the page shows.
`.trim();

export const BUILD_QUOTE_MANIFEST_KB = `
${BUILD_QUOTE_SALES_FLOW}

PROJECT TYPES (on /build):
- Mobile app, Web application, AI agent/automation, SaaS platform, Integration/API, E-commerce

CHECKOUT:
- Deposit: 30% of AI-quoted total, or pay full amount
- Copy Stripe payment link from saved quote page (dynamic amount)
- Stripe checkout on saved quote page

TRIGGERS: build an app, mobile app, custom software, get a quote, how much to build, SaaS MVP, hire SELF Labs to build
`.trim();
